import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      canvasSize: 'common/getCanvasSize',
      deviceType: 'common/getDeviceType',
      paramsClient: 'getParamsClients',
    }),
  },
  methods: {
    postcss(css, orientation) {
      let mode = {};
      if (
        this.paramsClient.display_devices !== null ||
        Object.keys(this.paramsClient.display_devices).length > 0
      ) {
        let nameDevices = this.paramsClient.display_devices.map(item => {
          return item.name;
        });
        let widthDevice = this.paramsClient.display_devices.map(item => {
          return item.width;
        });

        this.paramsClient.display_devices.forEach((item, index) => {
          mode = this.addToObject(mode, nameDevices[index], widthDevice[index]);
        });

        let orientationMode = mode[orientation] ? mode[orientation] : mode[Object.keys(mode)[0]];
        var unitCss = (innerWidth * parseFloat(orientationMode.replace('vw', ''))) / 100 / 100;
        css = this.fontSizeToVw(css);

        if (
          this.paramsClient.display_devices &&
          this.paramsClient.display_devices[0] &&
          !!!this.paramsClient.display_devices[0].fixedSize
        ) {
          css = this.fontSizePtTovw(css);
        }
        css = this.fontSizeEmTovw(css);
        css = this.widthHeightToViewport(css, true);

        return css ? css.replace(/[\d.]+vw/g, val => {
          return unitCss * parseFloat(val) + 'px';
        }) : "";
      }
    },
    addToObject(obj, key, value, index) {
      var temp = {};
      var i = 0;
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          if (i === index && key && value) {
            temp[key] = value;
          }
          temp[prop] = obj[prop];
          i++;
        }
      }
      if (!index && key && value) {
        temp[key] = value;
      }
      return temp;
    },
    fontSizeToVw(css) {
      const unitCss = this.canvasSize.width / 100;
      return css.replace(/font-size:((\d)+\.?(\d)*)px/g, val => {
        let newVal = parseFloat(val.replace('font-size:', '').replace('px', ''));
        return 'font-size:' + newVal / unitCss + 'vw';
      });
    },
    fontSizePtTovw(css) {
      const unitCss = this.canvasSize.width / 100;
      return css.replace(/font-size:((\d)+\.?(\d)*)pt/g, val => {
        let Val = parseFloat(val.replace('font-size:', '').replace('pt', ''));
        let newVal = Val / (3 / 4);
        return 'font-size:' + newVal / unitCss + 'vw';
      });
    },
    fontSizeEmTovw(css) {
      // this for  height Filet in  preview
      const unitCss = this.canvasSize.width / 100;
      return css.replace(/height:((\d)+\.?(\d)*)em/g, val => {
        let Val = parseFloat(val.replace('height:', '').replace('em', ''));
        let newVal = Val * 16;
        return 'height:' + newVal / unitCss + 'vw';
      });
    },

    widthHeightToViewport(css, isPreviewMode) {
      //TODO should be dynamic
      let devices = {};
      if (
        this.paramsClient.display_devices !== null ||
        Object.keys(this.paramsClient.display_devices).length > 0
      ) {
        let nameDevices = this.paramsClient.display_devices.map(item => {
          return item.name;
        });
        let widthDevice = this.paramsClient.display_devices.map(item => {
          return item.width;
        });
        let heightDevice = this.paramsClient.display_devices.map(item => {
          return item.height;
        });

        this.paramsClient.display_devices.forEach((item, index) => {
          let sizeDevices = {
            w: widthDevice[index],
            h: heightDevice[index],
          };
          devices = Object.assign(devices, this.addToObject({}, nameDevices[index], sizeDevices));
        });

        let deviceType = devices[this.deviceType] ? devices[this.deviceType] : devices[Object.keys(devices)[0]];
        const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        const offsetWidth = (w * (isPreviewMode ? deviceType.w : 100)) / 100;
        const offsetHeight =
          (w * (isPreviewMode ? deviceType.h : (100 * h) / w)) / 100;
        const prop = { w: offsetWidth / w, h: offsetHeight / h };
        return css.replace(/(height|width):\d+\.?\d*px/g, val => {
          return val.replace('px', 'v' + val.charAt(0)).replace(/\d+\.?\d*/g, v => {
            return (v / this.canvasSize[val.split(':')[0]]) * 100 * prop[val.charAt(0)];
          });
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/PostCssVw.js